<!--案例详情-->
<template>
  <div class="new-box">
    <div class="page-banner flex-column-c-c">
      <div class="red-zz"></div>
      <div class="banner-title">集团案例</div>
      <div class="banner-line"></div>
    </div>
    <div class="detail-box">
      <div class="detail-nav flex-c">
        <span>当前位置：</span>
        <el-breadcrumb separator=">">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/case'}">集团案例</el-breadcrumb-item>
          <el-breadcrumb-item>详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="detail-column-center flex-column-c-c">
        <div class="col-title">{{detailData.title}}</div>
        <div class="col-en"><span class="el-icon-time margin_right5"></span>{{detailData.created_at}}</div>
        <div class="col-line"></div>
      </div>
<!--      <div class="detail-column-left flex-e">-->
<!--        <div class="col-title">客户案例</div>-->
<!--        <div class="col-en">Customer case</div>-->
<!--      </div>-->
      <div class="detail-main">
        <iframe v-if="detailData.pdf_path" id="detail-iframe" class="detail-iframe" style="margin: 0 auto;display: block;" width="950" height="1140"
                :src="`${ajaxUrl}${detailData.pdf_path}` + '#toolbar=0'" type="application/pdf">
        </iframe>
        <div class="detail-content" v-html="detailData.content"></div>
      </div>
    </div>
<!--    <MessageFrom></MessageFrom>-->
    <Footer></Footer>
  </div>
</template>

<script>
  import MessageFrom from "../components/MessageFrom";
  import {ajaxGet, ajaxPost,ajaxUrl} from "../utils/ajax";
  import Footer from "../components/Footer";
  export default {
    name: "CaseDetail",
    data(){
      return {
        ajaxUrl,
        detailData:{},
      }
    },
    components: {Footer, MessageFrom},
    mounted() {
      this.$emit('handleRed', false);
      this.fetchDetail(this.$route.query.id);
    },
    methods: {
      fetchDetail(id){
        ajaxGet({
          url: `ajaxCaseDetail`,
          params:{id,},
          success(res){
            const {code, data, msg} = res;
            if(code === 200) {
              this.detailData = data;
            }
          },
        },this);
      }
    },
  }
</script>

<style scoped lang="scss">
  .new-box {
    width: 100%;background: $color-white;
    .page-banner {
      width: 100%;height: 500px;background: url('../assets/case_banner.png') no-repeat center/cover;padding-top: 2%;position: relative;
      /*.red-zz { position: absolute;width: 100%;height: 240px;background: linear-gradient(180deg,rgba($theme-color,.7),transparent);top: 0;left: 0;z-index: 2;}*/
      .banner-title { font-size: 60px;color: $color-white;letter-spacing: 1px;}
      .banner-line { width: 110px;height: 3px;background: $color-white;margin-top: 42px;}
    }
    .detail-column-center {
      margin: 30px 0;
      .col-title { font-size: 30px;letter-spacing: 2px;text-align: center;}
      .col-en { font-size: 15px;letter-spacing: 1px;margin-top: 4px;}
      .col-line { width: 50px;height: 6px;background: $theme-color;margin-top: 14px;}
    }
    .detail-column-left {
      line-height: 1;margin: 40px 48px;
      .col-title { font-size: 30px;color: $theme-color;letter-spacing: 2px;margin-right: 10px;}
      .col-en { font-size: 18px;color: #999;text-transform: uppercase;letter-spacing: 1px;}
    }
    .detail-box {
      width: 1200px;margin: 20px auto 50px auto;
      .detail-main {
        border: 1px solid #E4E4E4;padding: 35px;margin-top: 30px;
        .detail-title { font-size: $font-size24;text-align: center}
        .detail-content { font-size: $font-size16;line-height: 1.8;}
        .detail-iframe {
          >>> #toolbar{display:none}
        }
      }
    }
  }
  @media screen and (max-width: 750px) {
    .new-box {
      .page-banner {
        height: 220px;padding-top: 10%;
        .banner-title { font-size: 30px;}
        .banner-line { width: 60px;height: 2px;margin-top: 12px;}
      }
      .detail-box {
        width: 100%;margin: 0;padding: 14px;
        .detail-nav {
          font-size: 12px;span { font-size: 13px;}
          >>> .el-breadcrumb__separator { margin: 0 5px;}
        }
        .detail-column-center {
          margin: 20px 0 12px 0;
          .col-title { font-size: 18px;letter-spacing: 0;}
          .col-en { font-size: 12px;margin-top: 2px;letter-spacing: 0;display: none;}
          .col-line { height: 2px;margin-top: 8px;width: 40px;}
        }
        .detail-main {
          padding: 4px;margin-top: 0;border: none;
          .detail-content {
            font-size: 14px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/CaseDetail.vue